import React, { useState } from "react";
import { Modal, Button, Form, Select, InputNumber, Input } from "antd";
import axios from "../../services/axiosConfig";
import Helper from "../../services/Helper";

const PaymentPopup = ({ show, close, details }) => {
  const { TextArea } = Input;
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const onFinish = async (values) => {
    try {
      setIsButtonDisabled(true);
      let obj = {
        ...{ updateId: details.id, pendingAmount: details.pendingAmount },
        ...values,
      };
      const data = await axios.patch("/update-price", obj).catch((error) => {
        Helper.ErrorHanlder(error);
      });
      if (data && data.data) close(data);
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
  };

  const handleCancel = () => {
    close();
  };

  return (
    <>
      <Modal
        title="Add Payment"
        open={show}
        onCancel={handleCancel}
        footer={false}
      >
        <Form
          size={"small"}
          onFinish={onFinish}
          labelCol={{
            span: 6,
          }}
          style={{
            marginTop: 30,
          }}
        >
          <Form.Item
            label="Amount"
            name="amount"
            rules={[
              {
                required: true,
                message: "Amount is required",
              },
            ]}
          >
            <InputNumber
              style={{
                width: 200,
              }}
            />
          </Form.Item>
          <Form.Item label="Paied By" name="paymentMethod">
            <Select
              defaultValue="Hand"
              style={{ width: "96%", height: "100%" }}
              options={[
                { value: "Hand", label: "Hand" },
                { value: "UPI", label: "UPI" },
              ]}
            />
          </Form.Item>
          <Form.Item
            label="Payment Type"
            name="type"
            rules={[
              {
                required: true,
                message: "Payment Type is required",
              },
            ]}
          >
            <Select
              defaultValue=""
              style={{ width: "96%", height: "100%" }}
              options={[
                { value: "", label: "Select" },
                { value: "credit", label: "Credit" },
                { value: "debit", label: "Debit" },
              ]}
            />
          </Form.Item>
          <Form.Item label="Note" name="notes">
            <TextArea
              autoSize={{
                minRows: 3,
                maxRows: 5,
              }}
            />
          </Form.Item>
          <Form.Item className="popup-submit">
            <Button className="popup-cancel-btn" onClick={handleCancel}>
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              className="popup-submit-btn"
              disabled={isButtonDisabled}
            >
              Create
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default PaymentPopup;
